import { render, staticRenderFns } from "./TrackingSupportButton.vue?vue&type=template&id=353431ba&"
import script from "./TrackingSupportButton.vue?vue&type=script&lang=ts&"
export * from "./TrackingSupportButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports